import React from 'react'

const CustomTag = ({ children, tag, ...other }) => {
    const Tag = tag
    if (Tag && children) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <Tag {...other}>{children}</Tag>
    }
    return null
}

export default CustomTag
